import { cn } from '@/lib/utils';

interface PageShellProps {
  children: React.ReactNode;
  className?: string;
  /** Use a narrower max-width for content-focused pages */
  narrow?: boolean;
}

/**
 * Consistent page wrapper for all app pages.
 * Provides responsive padding, max-width centering, and prevents horizontal overflow.
 */
export function PageShell({ children, className, narrow = false }: PageShellProps) {
  return (
    <div
      className={cn(
        'min-h-screen w-full overflow-x-hidden',
        'px-4 sm:px-6 lg:px-8',
        'py-6 sm:py-8',
        narrow ? 'max-w-2xl' : 'max-w-6xl',
        'mx-auto',
        className
      )}
    >
      {children}
    </div>
  );
}
